import { PasswordReset } from '~/Api/Authentication/Password';

import ActionTypes from './ActionTypes';

export interface State {
	token: string | null;
	userId: string | null;
	request: Promise<any> | null;
	reset: PasswordReset | null;
}

type Action =
	| {
			type: ActionTypes.requestReset;
			token: string;
			userId: string;
			request: Promise<any>;
	  }
	| { type: ActionTypes.receiveReset; request: Promise<any>; reset: PasswordReset | null }
	| { type: ActionTypes.requestPasswordUpdate; request: Promise<any> }
	| { type: ActionTypes.receivePasswordUpdate; request: Promise<any> };

function createState(): State {
	return {
		token: null,
		userId: null,
		request: null,
		reset: null,
	};
}

export default function reducer(state: State = createState(), action: Action): State {
	switch (action.type) {
		case ActionTypes.requestReset:
			return {
				...state,
				token: action.token,
				userId: action.userId,
				request: action.request,
			};

		case ActionTypes.receiveReset:
			return state.request === action.request ? { ...state, request: null, reset: action.reset } : state;

		case ActionTypes.requestPasswordUpdate:
			return { ...state, request: action.request };

		case ActionTypes.receivePasswordUpdate:
			return state.request === action.request ? { ...state, request: null } : state;

		default:
			return state;
	}
}
